import { apiClient } from './client';

/** One widget on the Home dashboard. `type` maps into the widget registry. */
export interface DashboardWidget {
  id: string;
  type: string;
  /** Columns spanned on the 12-column grid, 1–12. */
  w: number;
  /** Pinned height in px; absent means size to content. A pinned height
   *  makes the widget body scroll rather than grow. */
  h?: number;
  config?: Record<string, any>;
}

export const dashboardApi = {
  /** `widgets: null` means the user has never customised — show the default. */
  getLayout: async (): Promise<DashboardWidget[] | null> => {
    const res = await apiClient.get('/dashboard/layout');
    return res.data.data.widgets as DashboardWidget[] | null;
  },

  saveLayout: async (widgets: DashboardWidget[]): Promise<DashboardWidget[]> => {
    const res = await apiClient.put('/dashboard/layout', { widgets });
    return res.data.data.widgets as DashboardWidget[];
  },

  resetLayout: async (): Promise<void> => {
    await apiClient.delete('/dashboard/layout');
  },
};
